import ListStore from '../../../shared-lib/stores/ListStore'
import ExternalTreatmentModel from './ExternalTreatmentModel'

export type $ExternalTreatmentLibrary = ExternalTreatmentLibrary

export default class ExternalTreatmentLibrary extends ListStore<ExternalTreatmentModel> {
  fetchMethodName = 'externalTreatmentLibrary'
  ModelClass = ExternalTreatmentModel
}
